import React from 'react'
import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useCopyToClipboard } from 'usehooks-ts'

export function ShareLinkPricingCampaign({
	pricingCampaignId,
	children,
}: {
	pricingCampaignId: string
	children: React.ReactNode
}) {
	const { t } = useTranslation()

	const [, copy] = useCopyToClipboard()
	const handleCopy = () => {
		copy(`${window.location.host}/p/pc?pc=${pricingCampaignId}`)
			.then(() => {
				toast.success(
					t('pc.action.link_copied', {
						defaultValue: 'Link copied to clipboard',
					})
				)
			})
			.catch(() => {
				toast.error(
					t('pc.action.link_copy_failed', {
						defaultValue: 'Failed to copy link',
					})
				)
			})
	}

	return <Slot.Root onClick={handleCopy}>{children}</Slot.Root>
}
